import { createAsyncThunk } from '@reduxjs/toolkit';
import { setModalClose, setModalError, setModalStatus } from '../../../slices';
import {
  fetchPublicProfileSavephone,
  type TPublicProfileSavephoneResponse,
} from '../../../repositories/monolith-cian-profileapi/profile/savephone';
import { IThunkApi } from '../../../types/referrer/store';
import { EModalStatus } from '../../../types/referrer/page';

interface IRequestPhoneValidationCodeParams {
  phone: string;
  code: string;
  onSuccess: () => void;
}

export const sendCodeAndAddPhone = createAsyncThunk<void, IRequestPhoneValidationCodeParams, IThunkApi>(
  'auth/verificateCode',
  async ({ phone, code, onSuccess }, _thunkApi) => {
    const {
      dispatch,
      extra: { logger, httpApi },
    } = _thunkApi;

    try {
      dispatch(setModalError(''));
      const res = (await fetchPublicProfileSavephone({
        httpApi,
        parameters: {
          phoneNumber: `+7${phone}`,
          confirmationCode: code,
        },
      })) as TPublicProfileSavephoneResponse;

      // @ts-ignore
      if (res.statusCode === 400) {
        dispatch(setModalError(res.response));

        return;
      }

      if (res.statusCode === 200) {
        dispatch(setModalClose());
        onSuccess();

        return;
      }

      dispatch(setModalStatus(EModalStatus.Error));

      return;
    } catch (e) {
      logger.debug('Ошибка отправки кода подтверждения', {
        message: e.message,
        domain: e.domain,
      });

      dispatch(setModalStatus(EModalStatus.Error));

      return;
    }
  },
);
